import { Box, Button, Container, Paper } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import Header from '../components/Header';
import { updateGuest } from '../features/inputSlice';

const SCREEN = 'signature';

const Signature = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sigCanvas = useRef<SignatureCanvas>(null);

  const handleBack = (event: React.MouseEvent<HTMLButtonElement>) => {
    navigate("/input");
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!sigCanvas.current?.isEmpty()) {
      const dataUrl = sigCanvas.current?.toDataURL();
      if (dataUrl) {
        dispatch(updateGuest({ id: 0, changes: { signature: dataUrl } }));
        navigate("/confirm");
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
        <Header title={t(`${SCREEN}.title`)} />
        <Box mt={2}>
          <Box
            border="2px dashed grey"
            sx={{
              width: '100%',
              height: 200,
              position: 'relative',
              backgroundColor: '#fff'
            }}
          >
            <SignatureCanvas
              ref={sigCanvas}
              penColor="black"
              canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, gap: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={handleBack}
              style={{ marginTop: '1rem' }}
            >
              {t(`${SCREEN}.back`)}
            </Button>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleSubmit}
              style={{ marginTop: '1rem' }}
            >
              {t(`${SCREEN}.next`)}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Signature;
